import { useQuery } from "@tanstack/react-query";
import { SelectField } from "@/components/ui/FormFields";
import { getMetros } from "@/api/public";

/**
 * A metro picker filled from GET /reference/metros. The codes are rows on the
 * server, so the Lab never types one by hand: a misspelt code is refused with
 * 400 UNKNOWN_METRO rather than answered with an empty list.
 */
export function MetroSelect({
  value,
  onChange,
  label = "Metro",
  placeholder,
}: {
  value: string;
  onChange: (code: string) => void;
  label?: string;
  /** Shown as the empty choice. Leave out when a metro is required. */
  placeholder?: string;
}) {
  const { data, isLoading } = useQuery({ queryKey: ["reference-metros"], queryFn: getMetros, staleTime: 3_600_000 });
  const metros = data?.data ?? [];
  return (
    <SelectField
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      options={metros.map((m) => ({ value: m.code, label: `${m.name} (${m.code})` }))}
      hint={isLoading ? "Loading metros…" : `${metros.length} metros from GET /reference/metros`}
    />
  );
}
